import React from 'react';
import { Plus, Edit2, Trash2 } from 'lucide-react';
import { Button } from '../ui/button';
import { Card } from '../ui/card';

export function AdminExercisesTab({ exercises, onCreateClick, onEditClick, onDelete }) {
  return (
    <>
      <div className='mb-6 flex justify-between items-center'>
        <h2 className='text-2xl font-bold text-[#1A3C34]' style={{ fontFamily: 'Clash Display' }}>Manage Exercises</h2>
        <Button data-testid='create-exercise-btn' onClick={onCreateClick} className='bg-[#D4F246] text-[#1A3C34] hover:bg-[#E2F585] rounded-full'>
          <Plus className='w-4 h-4 mr-2' /> Add Exercise
        </Button>
      </div>
      <div className='space-y-4'>
        {exercises.map((exercise, index) => (
          <Card key={exercise.id} className='p-6 bg-white rounded-2xl' data-testid={`exercise-card-${index}`}>
            <div className='flex justify-between items-start'>
              <div className='flex-1'>
                <h3 className='text-lg font-bold text-[#1A3C34] mb-1'>{exercise.title}</h3>
                <p className='text-gray-600 text-sm mb-2'>{exercise.description}</p>
                <div className='flex gap-2 text-xs'>
                  <span className='bg-gray-100 px-2 py-1 rounded'>{exercise.category}</span>
                  <span className='bg-gray-100 px-2 py-1 rounded capitalize'>{exercise.difficulty}</span>
                  <span className='bg-gray-100 px-2 py-1 rounded'>{exercise.duration_minutes} min</span>
                </div>
              </div>
              <div className='flex gap-2'>
                <Button size='sm' variant='outline' onClick={() => onEditClick(exercise)}>
                  <Edit2 className='w-4 h-4' />
                </Button>
                <Button size='sm' variant='outline' onClick={() => onDelete(exercise.id)} data-testid={`delete-exercise-${index}`}>
                  <Trash2 className='w-4 h-4' />
                </Button>
              </div>
            </div>
          </Card>
        ))}
      </div>
    </>
  );
}
